/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.howToUse[_ngcontent-%COMP%] {position:relative; top:70px; text-align:center; font-family: Hanna, sans-serif;}\n.howToUse[_ngcontent-%COMP%]   p[_ngcontent-%COMP%] {margin-top:15px; font-size:17px; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvZ2l0bGFiLXJ1bm5lci9idWlsZHMvZDkwYzViY2YvMC9nYWlhL2dhaWEtdWktYW5ndWxhci9zcmMvYXBwL3Bvc3Rlci9ob3ctdG8tdXNlL2hvdy10by11c2UuY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL2dpdGxhYi1ydW5uZXIvYnVpbGRzL2Q5MGM1YmNmLzAvZ2FpYS9nYWlhLXVpLWFuZ3VsYXIvc3JjL2FwcC9wb3N0ZXIvaG93LXRvLXVzZS9ob3ctdG8tdXNlLmNvbXBvbmVudC5jc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/$$_gendir/app/poster/how-to-use/how-to-use.component.css.shim.ngstyle.ts